import React from 'react'
import { useContext } from 'sb-hooks'
import cx from 'classnames'

import RadioGroupContext from '../RadioGroupContext/RadioGroupContext'

import s from './RadioButtonContainer.scss'


type RadioContainerProps = {
  className?: string
  inputClassName?: string
  value: string | number
  dataTestId?: string
}

const RadioButtonContainer: React.FunctionComponent<RadioContainerProps> = (props) => {
  const { children, className, inputClassName, value, dataTestId } = props

  const { activeValue, name, onChange } = useContext(RadioGroupContext)

  const nodeProps = {
    className: cx(s.input, inputClassName),
    type: 'radio',
    name,
    value,
    checked: activeValue === value,
    onChange,
  }

  return (
    <label className={className} data-testid={dataTestId}>
      <input {...nodeProps} />
      {children}
    </label>
  )
}


export default RadioButtonContainer
